'use client';
import clsx from 'clsx';
import { useCallback } from 'react';
import { Button, ListBox, ListBoxItem, Popover, Select, SelectValue, } from 'react-aria-components';
import { useStore } from 'zustand';
import { getOrCreateStoreByKey } from './getOrCreateStoreByKey';
export function useSelectState(stateKey, initialKey) {
    if (stateKey === void 0) { stateKey = 'select-state'; }
    var store = useStore(getOrCreateStoreByKey(stateKey, initialKey));
    return {
        key: store.key,
        setKey: useCallback(function (key) { return store.setKey(key); }, [store.setKey]),
    };
}
export function OpenAPISelect(props) {
    var _a;
    var _b = props.icon, icon = _b === void 0 ? '▼' : _b, items = props.items, children = props.children, className = props.className, placement = props.placement, stateKey = props.stateKey, selectedKey = props.selectedKey, onSelectionChange = props.onSelectionChange;
    var state = useSelectState(stateKey, (_a = items[0]) === null || _a === void 0 ? void 0 : _a.key);
    var selected = items.find(function (item) { return item.key === state.key; }) || items[0];
    return (<Select aria-label="OpenAPI Select" {...props} selectedKey={selectedKey || (selected === null || selected === void 0 ? void 0 : selected.key)} onSelectionChange={function (key) {
            onSelectionChange === null || onSelectionChange === void 0 ? void 0 : onSelectionChange(key);
            state.setKey(key);
        }} className={clsx('openapi-select', className)}>
            <Button>
                <SelectValue />
                {icon}
            </Button>
            <Popover placement={placement} className="openapi-select-popover">
                <ListBox className="openapi-select-listbox" items={items}>
                    {children}
                </ListBox>
            </Popover>
        </Select>);
}
export function OpenAPISelectItem(props) {
    return (<ListBoxItem {...props} className={function (_a) {
            var isFocused = _a.isFocused, isSelected = _a.isSelected;
            return clsx('openapi-select-item', {
                'openapi-select-item-focused': isFocused,
                'openapi-select-item-selected': isSelected,
            });
        }}/>);
}
